import ChatHistoryContainer from './chatHistoryContainer'

export default ChatHistoryContainer